import { render, staticRenderFns } from "./AsACoachCheckpointInspectionBar.vue?vue&type=template&id=435782e5&scoped=true"
import script from "./AsACoachCheckpointInspectionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachCheckpointInspectionBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachCheckpointInspectionBar.vue?vue&type=style&index=0&id=435782e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435782e5",
  null
  
)

export default component.exports